// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import { get } from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import Flatpickr from 'react-flatpickr'
import { FormFieldLayout } from '../../generic'

export default function DateTimeField({
  errors,
  formKey,
  onChange,
  showAge,
  placeholder,
  style,
  age,
  values,
  children,
  ...props
}) {
  const error = get(errors, formKey)
  const value = get(values, formKey)

  const { timeLogged } = values
  const [currentDate, setCurrentDate] = useState('')

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const handleDateTimeChange = () => {
      onChange({
        key: formKey,
        value: moment().toISOString()
      })
    }

    if (moment(timeLogged).isAfter(moment())) {
      handleDateTimeChange()
    } else {
      setCurrentDate(timeLogged)
    }
  }, [timeLogged])

  const handleTimeChange = (newDate) => {
    const d = moment(newDate[0])
    onChange({
      key: formKey,
      value: moment(currentDate)
        .set('hour', d.get('hour'))
        .set('minute', d.get('minute'))
        .valueOf()
    })
  }

  const handleDateChange = (newDate) => {
    const current = moment(currentDate)

    const d = moment(newDate[0])
    const value = d
      .set('hour', current?.get('hour'))
      .set('minute', current?.get('minute'))

    onChange({
      key: formKey,
      value: value.valueOf()
    })
  }

  const renderTimePicker = () => {
    if (!currentDate) return null

    const date_options = {
      dateFormat: 'd-m-Y',
      defaultDate: currentDate,
      maxDate: new Date()
    }

    const time_options = {
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      defaultDate: currentDate,
      time_24hr: true,
      maxDate: moment().isSame(currentDate, 'day') ? new Date() : false
    }

    return (
      <div className={css(classes.timeInputContainer)}>
        <Flatpickr
          className={css(classes.input, classes.dateInput)}
          options={date_options}
          value={currentDate}
          onChange={handleDateChange}
          data-testid={
            props['data-testid']
              ? `${props['data-testid']}-date`
              : 'datetime-field-date'
          }
        />
        <Flatpickr
          className={css(classes.input, classes.timeInput)}
          options={time_options}
          value={currentDate}
          onChange={handleTimeChange}
          data-testid={
            props['data-testid']
              ? `${props['data-testid']}-time`
              : 'datetime-field-time'
          }
        />
      </div>
    )
  }

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <div style={{ display: 'flex' }}>
        <div
          style={{
            flex: value ? 1 : null,
            marginRight: value ? 15 : null,
            width: '100%'
          }}
        >
          {renderTimePicker()}
        </div>
        {children}
      </div>
    </FormFieldLayout>
  )
}

const classes = StyleSheet.create({
  timeInputContainer: {
    display: 'flex'
  },
  input: {
    textAlign: 'center',
    border: `1px solid ${colors.grey}`,
    borderRadius: 4,
    width: 100,
    letterSpacing: 1,
    padding: '8px 4px'
  },
  dateInput: {
    marginRight: 15
  }
})
